<template>
  <el-popover placement="bottom"
              trigger="click">
    <el-scrollbar style="height: 100%;">
      <el-tree style="max-height:400px; min-width:240px;"
               ref="classroomClassTree"
               :data="classroomClassData"
               show-checkbox
               check-strictly
               node-key="classroomClassId"
               @check-change="handleCheckChange"
               :default-checked-keys="defaultCheckedKeys"
               :props="defaultProps"
               default-expand-all></el-tree>
    </el-scrollbar>
    <el-input slot="reference"
              placeholder="请选择教室分类"
              clearable
              size="mini"
              readonly
              class="classroom-class"
              v-model.trim="classroomClass.showValue"></el-input>
  </el-popover>
</template>
<script>
let mockDataList = [
  {
    'classroomClassId': 1,
    'classroomName': '实体教室',
    'levelParentId': 0,
    'isLeaf': false,
    'disabled': true,
    'classroomClassChildList': [
      {
        'classroomClassId': 2,
        'classroomName': '技术',
        'levelParentId': 1,
        'isLeaf': true,
        'classroomClassChildList': []
      },
      {
        'classroomClassId': 3,
        'classroomName': '非技术',
        'levelParentId': 1,
        'isLeaf': true,
        'classroomClassChildList': []
      },
      {
        'classroomClassId': 4,
        'classroomName': '其他',
        'levelParentId': 1,
        'isLeaf': true,
        'classroomClassChildList': []
      }
    ]
  },
  {
    'classroomClassId': 5,
    'classroomName': '虚拟教室',
    'levelParentId': 0,
    'isLeaf': false,
    'disabled': true,
    'classroomClassChildList': [
      {
        'classroomClassId': 6,
        'classroomName': '直播',
        'levelParentId': 2,
        'isLeaf': true,
        'classroomClassChildList': []
      },
      {
        'classroomClassId': 7,
        'classroomName': 'WebEx',
        'levelParentId': 2,
        'isLeaf': true,
        'classroomClassChildList': []
      }
    ]
  }
]
export default {
  name: 'classroom-class',
  props: {
    defaultCheckedId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      treeCount: 0,
      defaultProps: {
        children: 'classroomClassChildList',
        label: 'classroomName'
      },
      classroomClassData: [],
      classroomClass: {
        value: '',
        showValue: ''
      },
      // 选中数据
      defaultCheckedKeys: [],
      // 是否继续遍历
      continueLoop: true
    }
  },
  methods: {
    handleCheckChange: function handleCheckChange (data, checked, arg3) {
      console.log(data, checked, arg3)
      this.treeCount++
      if (data.isLeaf) {
        if (checked) {
          this.$refs.classroomClassTree.setCheckedKeys([])
          this.$refs.classroomClassTree.setCheckedNodes([data])
          this.classroomClass.value = data.classroomClassId
          this.classroomClass.showValue = data.classroomName
          this.$emit('setClassroomClassId', data.classroomClassId)
          // 交叉点击节点
        } else {
          this.$refs.classroomClassTree.setCheckedNodes([])
          // 点击已经选中的节点，置空
          this.classroomClass.value = ''
          this.classroomClass.showValue = ''
          this.$emit('setClassroomClassId', '')
        }
        this.$forceUpdate()
      }
    },
    getDefaultCheckedKeys (arr) {
      console.log('arr=====>', arr)
      if (this.continueLoop) {
        for (let i = 0; i < arr.length; i++) {
          let item = arr[i]
          console.log(item)
          if (String(item.classroomClassId) === String(this.defaultCheckedId)) {
            this.defaultCheckedKeys.push(this.defaultCheckedId)
            this.classroomClass.value = item.classroomClassId
            this.classroomClass.showValue = item.classroomName
            this.$emit('setClassroomClassId', item.classroomClassId)
            this.continueLoop = false
            break
          } else if (item.classroomClassChildList && item.classroomClassChildList.length > 0) {
            this.getDefaultCheckedKeys(item.classroomClassChildList)
          }
        }
      }
    }
  },
  mounted: function () {
    this.classroomClassData = mockDataList
    if (this.defaultCheckedId) {
      console.log('this.defaultCheckedId==========>', this.defaultCheckedId)
      console.log('<================================>')
      this.getDefaultCheckedKeys(this.classroomClassData)
      console.log('<================================>')
    }
  }
}
</script>
<style>
.classroom-class > .el-input__inner {
  width: 100%;
  height: 32px !important;
}
</style>

<style scoped>
.el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
